/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateMessages = /* GraphQL */ `subscription OnCreateMessages($presentationId: String!) {
  onCreateMessages(presentationId: $presentationId) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMessagesSubscriptionVariables,
  APITypes.OnCreateMessagesSubscription
>;
export const onUpdateMessages = /* GraphQL */ `subscription OnUpdateMessages($presentationId: String!) {
  onUpdateMessages(presentationId: $presentationId) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMessagesSubscriptionVariables,
  APITypes.OnUpdateMessagesSubscription
>;
export const onDeleteMessages = /* GraphQL */ `subscription OnDeleteMessages($presentationId: String!) {
  onDeleteMessages(presentationId: $presentationId) {
    messageId
    message
    presentationId
    senderEmail
    senderName
    sentDate
    state
    lastChanges
    presentationTitle
    prioritizeIndex
    senderStatus
    aiResponse
    topic
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMessagesSubscriptionVariables,
  APITypes.OnDeleteMessagesSubscription
>;
export const onBatchUpdateMessages = /* GraphQL */ `subscription OnBatchUpdateMessages($presentationId: String!) {
  onBatchUpdateMessages(presentationId: $presentationId) {
    items {
      messageId
      message
      presentationId
      senderEmail
      senderName
      sentDate
      state
      lastChanges
      presentationTitle
      prioritizeIndex
      senderStatus
      aiResponse
      topic
      __typename
    }
    presentationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnBatchUpdateMessagesSubscriptionVariables,
  APITypes.OnBatchUpdateMessagesSubscription
>;
export const onCreateInterfaceSettings = /* GraphQL */ `subscription OnCreateInterfaceSettings($presentationId: String!) {
  onCreateInterfaceSettings(presentationId: $presentationId) {
    presentationId
    reviewMode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateInterfaceSettingsSubscriptionVariables,
  APITypes.OnCreateInterfaceSettingsSubscription
>;
export const onUpdateInterfaceSettings = /* GraphQL */ `subscription OnUpdateInterfaceSettings($presentationId: String!) {
  onUpdateInterfaceSettings(presentationId: $presentationId) {
    presentationId
    reviewMode
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateInterfaceSettingsSubscriptionVariables,
  APITypes.OnUpdateInterfaceSettingsSubscription
>;
export const onCreateChatMessages = /* GraphQL */ `subscription OnCreateChatMessages($presentationId: String!) {
  onCreateChatMessages(presentationId: $presentationId) {
    chatMessageId
    presentationId
    senderName
    createdAt
    message
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateChatMessagesSubscriptionVariables,
  APITypes.OnCreateChatMessagesSubscription
>;
export const onChangeSlides = /* GraphQL */ `subscription OnChangeSlides($presentationId: String!) {
  onChangeSlides(presentationId: $presentationId) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    concurrencyUserId
    currentSlideIndex
    presentationId
    userName
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnChangeSlidesSubscriptionVariables,
  APITypes.OnChangeSlidesSubscription
>;
export const onUpdatePoll = /* GraphQL */ `subscription OnUpdatePoll($presentationId: String!) {
  onUpdatePoll(presentationId: $presentationId) {
    pollId
    presentationId
    hideForPresenter
    order
    status
    type
    value
    publicAdjustment
    poll_in_progress_timestamp
    poll_completed_timestamp
    countVotes
    result_slide_added
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePollSubscriptionVariables,
  APITypes.OnUpdatePollSubscription
>;
export const onCreatePoll = /* GraphQL */ `subscription OnCreatePoll($presentationId: String!) {
  onCreatePoll(presentationId: $presentationId) {
    presentationId
    Polls {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    PollChoices {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePollSubscriptionVariables,
  APITypes.OnCreatePollSubscription
>;
export const onDeletePoll = /* GraphQL */ `subscription OnDeletePoll($presentationId: String!) {
  onDeletePoll(presentationId: $presentationId) {
    presentationId
    Polls {
      pollId
      presentationId
      hideForPresenter
      order
      status
      type
      value
      publicAdjustment
      poll_in_progress_timestamp
      poll_completed_timestamp
      countVotes
      result_slide_added
      __typename
    }
    PollChoices {
      pollId
      pollChoiceId
      isCustomResponse
      order
      value
      status
      count
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePollSubscriptionVariables,
  APITypes.OnDeletePollSubscription
>;
export const onPollCommand = /* GraphQL */ `subscription OnPollCommand($presentationId: String!) {
  onPollCommand(presentationId: $presentationId) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    livePresentationId
    presentationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnPollCommandSubscriptionVariables,
  APITypes.OnPollCommandSubscription
>;
export const onSavePollVotes = /* GraphQL */ `subscription OnSavePollVotes($presentationId: String!) {
  onSavePollVotes(presentationId: $presentationId) {
    pollVotesCount {
      pollChoiceId
      count
      __typename
    }
    allVotesCount
    presentationId
    pollId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSavePollVotesSubscriptionVariables,
  APITypes.OnSavePollVotesSubscription
>;
export const onPublishSegments = /* GraphQL */ `subscription OnPublishSegments($presentationId: String!) {
  onPublishSegments(presentationId: $presentationId) {
    segments
    action
    atIndex
    presentationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnPublishSegmentsSubscriptionVariables,
  APITypes.OnPublishSegmentsSubscription
>;
export const onKnovioPublishCommand = /* GraphQL */ `subscription OnKnovioPublishCommand($livePresentationId: String!) {
  onKnovioPublishCommand(livePresentationId: $livePresentationId) {
    livePresentationId
    idHash
    presentationLink
    liveCommand {
      type
      backup_stream
      backup_stream_time
      stream_time
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnKnovioPublishCommandSubscriptionVariables,
  APITypes.OnKnovioPublishCommandSubscription
>;
export const onKnovioCommand = /* GraphQL */ `subscription OnKnovioCommand($livePresentationId: String!) {
  onKnovioCommand(livePresentationId: $livePresentationId) {
    backup_stream
    backup_stream_time
    content
    stream_time
    type
    livePresentationId
    presentationId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnKnovioCommandSubscriptionVariables,
  APITypes.OnKnovioCommandSubscription
>;
